import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import FormSkeleton from "@/components/loadings/skeleton/FormSkeleton";
import type { ChildRouteContext } from "@/root";

import { EditCheckinPage } from "../../../../components/checkins/EditCheckinPage";
import { fetchCheckinQueryOptions } from "../../../../services";

export const Route = createFileRoute(
  "/_panel/_performance/performance/checkins/$id",
)({
  component: RouteComponent,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Periodic Meetings", {
            ns: "performance.user",
          }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchCheckinQueryOptions(opts.params.id),
    ),
  pendingComponent: FormSkeleton,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <EditCheckinPage id={id} />;
}
